import { render, staticRenderFns } from "./On-the-road.vue?vue&type=template&id=0ed74829"
import script from "./On-the-road.vue?vue&type=script&lang=js"
export * from "./On-the-road.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports